export default "/images/project-pulsewalker-main.png";